import { CenterPage } from "pages/PageTemplates";
import { FullPageSpinner } from "styles/components";
import { CenterFlexColumn } from "styles/layout";
import { LoadingLogoImage, LoadingText } from "./styles";

export const LoadingPage = () => {
  return (
    <CenterPage>
      <CenterFlexColumn>  
        <LoadingLogoImage src={"/images/ecm/logo_text.png"} />
        <LoadingText>Track the latest TrackMania eSports<br/>Get real-time rankings, tournament results, statistics, and make predictions</LoadingText>
        <FullPageSpinner />
      </CenterFlexColumn>
    </CenterPage>
  );
};
